import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getBodyCopy(precedenceToRemove, secondaryIsEnabled, method) {
  const rootKey = 'userPreferences.2fa.removeMethod';
  if (secondaryIsEnabled && precedenceToRemove === TwoFactorAuthPrecedenceTypes.PRIMARY) {
    return `${rootKey}.primary.bodyWhenSecondaryEnabled`;
  }
  return `${rootKey}.${precedenceToRemove.toLowerCase()}.body.${method.toLowerCase()}`;
}
const RemoveTwoFactorAuth = ({
  precedence,
  method,
  secondaryIsEnabled,
  onConfirmRemoval,
  onConfirmRemoveAll,
  onCancel
}) => /*#__PURE__*/_jsxs(UIModal, {
  width: 600,
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onCancel
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.2fa.removeMethod.${precedence.toLowerCase()}.title`
      })
    })]
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getBodyCopy(precedence, secondaryIsEnabled, method)
      })
    })
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [precedence === TwoFactorAuthPrecedenceTypes.SECONDARY || precedence === TwoFactorAuthPrecedenceTypes.PRIMARY && !secondaryIsEnabled ? /*#__PURE__*/_jsx(UIButton, {
      use: "danger",
      onClick: onConfirmRemoval,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.2fa.removeMethod.turnOffConfirm"
      })
    }) : null, precedence === TwoFactorAuthPrecedenceTypes.PRIMARY && secondaryIsEnabled ? /*#__PURE__*/_jsx(UIButton, {
      use: "danger",
      onClick: onConfirmRemoveAll,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.2fa.removeMethod.turnOffAll"
      })
    }) : null, precedence === TwoFactorAuthPrecedenceTypes.PRIMARY && secondaryIsEnabled ? /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onConfirmRemoval,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.2fa.removeMethod.turnOffAndPromote"
      })
    }) : null, precedence === TwoFactorAuthPrecedenceTypes.SECONDARY || precedence === TwoFactorAuthPrecedenceTypes.PRIMARY && !secondaryIsEnabled ? /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.2fa.removeMethod.cancel"
      })
    }) : null]
  })]
});
RemoveTwoFactorAuth.propTypes = {
  precedence: PropTypes.oneOf([TwoFactorAuthPrecedenceTypes.PRIMARY, TwoFactorAuthPrecedenceTypes.SECONDARY]).isRequired,
  method: PropTypes.oneOf([TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR, TwoFactorAuthMethods.SMS, TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR]).isRequired,
  secondaryIsEnabled: PropTypes.bool.isRequired,
  onConfirmRemoval: PropTypes.func.isRequired,
  onConfirmRemoveAll: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};
export default RemoveTwoFactorAuth;